import { z } from 'zod';

// Responsables por documento (spec 2026-10-14 §1): una persona del QMS o un puesto del
// LMS por rol. Contrato de GET /api/v1/quality/positions.

export const RESPONSIBILITY_ROLES = ['elaborador', 'revisor', 'aprobador', 'capacitador'] as const;
export type ResponsibilityRole = (typeof RESPONSIBILITY_ROLES)[number];

export const positionSchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  code: z.string(),
});
export type Position = z.infer<typeof positionSchema>;

export const positionsResponseSchema = z.object({
  success: z.literal(true),
  data: z.array(positionSchema),
});

export type AssignBody =
  | { role: ResponsibilityRole; userId: string }
  | { role: ResponsibilityRole; positionId: number };
